import {ResponseInterface} from "@/types/Response";
import {Address} from "@/util/Address";
import {Currency} from "@/enums/Currency";
import {User} from "@/util/User";
import {Member} from "@/util/Member";
import {OrderItem} from "@/util/OrderItem";
import {ResponseCustomer} from "@/util/ResponseCustomer";

export class Response extends ResponseCustomer implements ResponseInterface {
  storeId: number | string;

  locationId?: number | string;
  locationCode?: string;

  currency: Currency;

  createdAt: Date;

  orderItems: OrderItem[];

  total: number;
  qty: number;

  memberList: Member[];

  constructor({createdAt, currency, locationId, memberList, orderItems, qty, storeId, total, customer, invoiceRecipient, locationCode}: ResponseConstructorPayload) {
    super(invoiceRecipient,customer);
    this.createdAt = createdAt;
    this.currency = currency;
    this.memberList = memberList;
    this.orderItems = orderItems;
    this.qty = qty;
    this.storeId = storeId;
    this.total = total;

    if(locationCode) {
      this.locationCode = locationCode
    } else {
      this.locationId = locationId;
    }
  }
}

interface ResponseConstructorPayload {
  createdAt: Date,
  currency: Currency,
  locationId: number | string,
  locationCode: string,
  memberList: Member[],
  orderItems: OrderItem[],
  qty: number,
  storeId: number | string,
  total: number,
  customer: User,
  invoiceRecipient: User
}
